/** @format */

import React, { useEffect, useState } from 'react';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import Error from '@material-ui/icons/ErrorOutline';
import CustomInput from '../../components/CustomInput/CustomInputExt';

import withStyles from '@material-ui/core/styles/withStyles';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { makeStyles, Popper } from '@material-ui/core';
import I18n from '../Translate/I18n';
import COLORS from '../../assets/themes/OPL/colors';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';

const inputFormErrorPopperStyle = {
    backgroundColor: COLORS.MAIN.DARK,
    color: COLORS.MAIN.LIGHT,
    padding: 10,
    zIndex: 9999999,
};

const useStyles = makeStyles(adescomStyle);

const InputFormRest = (props) => {
    const classes = useStyles();
    const {
        callback,
        disabled,
        status,
        stateName,
        typeCallback,
        typeField,
        displayFieldName,
        vMax,
        vMin,
        required,
        autoComplete,
        stateObjectState,
        step,
        ...rest
    } = props;
    const [inputErrors, setInputErrors] = useState([]);
    const [displayErrorsModal, setDisplayErrorsModal] = useState(null);

    const onMouseEnterHandler = (event) => {
        setDisplayErrorsModal(
            <Popper style={inputFormErrorPopperStyle} open={true} anchorEl={event.currentTarget}>
                {inputErrors.map((el, index) => {
                    return (
                        <div key={index}>
                            <I18n trans={el} />
                        </div>
                    );
                })}
            </Popper>
        );
    };

    const onMouseLeaveHandler = () => {
        setDisplayErrorsModal(null);
    };

    useEffect(() => {
        if (inputErrors.length === 0 && displayErrorsModal) {
            setDisplayErrorsModal(null);
        }
    }, [inputErrors, displayErrorsModal]);

    return (
        <>
            <CustomInput
                {...rest}
                success={stateName === FormGeneralHelper.SUCCESS}
                error={stateName === FormGeneralHelper.ERROR}
                labelText={displayFieldName}
                id={stateName}
                formControlProps={{
                    fullWidth: true,
                }}
                required={required}
                inputProps={{
                    step,
                    onChange: (event) => {
                        setInputErrors(FormGeneralHelper.verifyInputFields(typeField, event.target.value, vMin, vMax, required));
                        callback(event, stateName, typeField, typeCallback, required, vMax, vMin);
                    },
                    type: typeField,
                    disabled: disabled || false,
                    endAdornment:
                        stateObjectState === FormGeneralHelper.ERROR ? (
                            <InputAdornment position="end">
                                <Error
                                    style={{
                                        cursor: 'default',
                                    }}
                                    className={classes.danger}
                                    onMouseEnter={onMouseEnterHandler}
                                    onMouseLeave={onMouseLeaveHandler}
                                />
                            </InputAdornment>
                        ) : (
                            undefined
                        ),
                }}
            />
            {displayErrorsModal}
        </>
    );
};

InputFormRest.propTypes = {
    classes: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    stateName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    stateObjectState: PropTypes.string,
    typeCallback: PropTypes.string.isRequired,
    typeField: PropTypes.string.isRequired,
    displayFieldName: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    vMax: PropTypes.number.isRequired,
    vMin: PropTypes.number,
    step: PropTypes.number,
    value: PropTypes.any,
};

export default withStyles(adescomStyle)(InputFormRest);
